import { Endereco } from '@usucampeao/interfaces';
import { Expose, plainToInstance } from 'class-transformer';
import { ProjetoModalidadeType } from './projeto-modalidade.enum';
import { ProjetoStatus } from './projeto-status.enum';
import { ProjetoTipo } from './projeto-tipo.enum';
import { ProjetoVendaStatus } from './projeto-venda-status.enum';
import { ProjetoDto } from './projeto.dto';

export class ProjetoSimplificadoDto {
  @Expose()
  id: string;

  @Expose()
  nome: string;

  @Expose()
  descricao?: string;

  @Expose()
  modalidade?: ProjetoModalidadeType;

  @Expose()
  averbacao?: boolean;

  @Expose()
  localizacao: Endereco;

  @Expose()
  tipo: ProjetoTipo;

  @Expose()
  vendaStatus: ProjetoVendaStatus;

  @Expose()
  status: ProjetoStatus;


  /**
    * Cria uma nova instância de ProjetoSimplificadoDto a partir de dtos
    * @param props DTO de ProjetoSimplificadoDto
    * @returns nova instância de ProjetoSimplificadoDto
    */
  static from(props?: Partial<ProjetoDto>): ProjetoSimplificadoDto {
    return plainToInstance(ProjetoSimplificadoDto, props, { exposeUnsetFields: false, excludeExtraneousValues: true });
  }
}
